// extracted by mini-css-extract-plugin
module.exports = {"user-menu-button":"UserProfileMenu_user-menu-button__dbeDg","user-menu":"UserProfileMenu_user-menu__0PisY","logout-link":"UserProfileMenu_logout-link__DCG9Y"};